import React from 'react';

import Badge from 'js/design_system/Badge';

/**
 * Risk-reversal badge rendered next to the CTA when V19
 * (`guarantee_badge_v19`) is active. Tests whether modal-level
 * risk-reversal lifts CTR (T13 extension — $1 is the friction point;
 * risk-reversal pairs with low friction).
 */
export function GuaranteeBadge() {
  return (
    <Badge
      icon="check_circle"
      iconSize={16}
      text="Cancel anytime · Full refund within 30 days"
    />
  );
}
